/**
 * RoofM2CalibrationPage — Sprint S3 · 2026-02c
 *
 * Full-page host for the calibration drawer. Route:
 *   /admin/roof-m2-calibration
 *
 * The drawer component doubles as the page body — same UI, no back-
 * drop. The office team can bookmark this page and check it monthly.
 */
import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { RoofM2CalibrationDrawer } from '@/components/RoofM2CalibrationDrawer';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { Authorization: `Bearer ${localStorage.getItem('access_token') || ''}` },
});

export default function RoofM2CalibrationPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="roof-m2-calibration-page">
      <div className="max-w-4xl mx-auto p-6">
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-800 mb-3"
        >
          <ArrowLeft size={12} /> Back
        </Link>
        {/* Drawer with open=true and a no-op onClose so the panel body
            renders as the page content. The fixed positioning wrapper
            keeps the same UI so the drawer + page look identical. */}
        <RoofM2CalibrationDrawer
          api={api}
          open={true}
          onClose={() => { /* page mode · nothing to close */ }}
          limit={20}
        />
      </div>
    </div>
  );
}
